import { useFetchEcompage } from "@/apis/queryFunctions/ecompagesFunctions";
import useTrans from "@/hooks/useTrans";
import useWindowSize from "@/hooks/useWindowSize";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import sanitizeDOMData from "@/utils/sanitizeDOMData";
import { Box, Container, Grid, Text, Title, } from '@mantine/core';
import { IconArrowRight } from "@tabler/icons-react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React from 'react';

function SanPham() {
  const trans = useTrans();
  const { locale } = useRouter();
  const { data } = useFetchEcompage("du-lieu-chung-viet-thien", locale);
  const { isTablet } = useWindowSize();
  const info = (data?.add_on_data || []).slice(0, 7)
  const products = [info[1], info[2], info[3]]
  const homeData = [
    { alt: 'trà Việt Thiên', href: "https://travietthien.com" },
    { alt: 'Zemor', href: "https://zemor.vn" },
    { alt: 'nông sản Việt Thiên', href: "https://www.facebook.com/nongsanchatluongcaoVietThien" },
  ]
  return (
    <div>
      <Box component="section">
        <Container size="xl" >
          {products && products.map((item, i) => (
            <Grid grow gutter="xl" justify="space-between" align="center" key={i}>
              <Grid.Col xs={12} md={7} sx={{}} orderMd={i % 2 !== 0 ? 2 : 1}>
                <Box sx={{ position: "relative", aspectRatio: "1.2", }} >
                  <Image src={appendImageUrlFromAPI({ src: item?.picture, size: "l" })} alt={homeData[i].alt} title={homeData[i].alt} layout="fill" objectFit="contain" loading="lazy" />
                </Box>
              </Grid.Col>
              <Grid.Col xs={12} md={5} sx={{}} align={isTablet ? "center" : "justify"} orderMd={i % 2 !== 0 ? 1 : 2}>
                <Title order={2} size="24px" weight="900" color="#212F3B">{sanitizeDOMData(item?.title)}</Title>
                <Text ta="justify">{sanitizeDOMData(item?.content)}</Text>
                <Link scroll={false} href={homeData[i].href} >
                  <a target='_blank'><Text size={16} weight={700} display="inline-flex" >{trans?.homeAbout.seeMore}<IconArrowRight size={20} style={{ margin: "3px 0 0 10px" }} /></Text></a>
                </Link>
              </Grid.Col>
            </Grid>
          ))}

        </Container>
      </Box>
    </div>
  );
}
export default SanPham;

